import { useLazyQuery } from '@apollo/client'
import { GraphQlEnum } from '../utils/Enums'

import * as AllAtoms from '../recoil/atoms'
import { useRecoilState } from 'recoil'

const useFetchLazyQuery = (props) => {
	const { segment, action, type } = props

	const segmentAtom = AllAtoms[GraphQlEnum[segment]?.fetch?.[action]?.atom]
	const query = GraphQlEnum[segment]?.fetch?.[action]?.queryName
	const outputFunction = GraphQlEnum[segment]?.fetch?.[action]?.queryOutput
	const [atom, setAtom] = useRecoilState(segmentAtom)
	const [queryFunction, { loading, error }] = useLazyQuery(query, {
		fetchPolicy: 'cache-and-network', // Used for first execution
		// nextFetchPolicy: 'cache-and-network', // Used for subsequent executions
		onCompleted: (data) => {
			if (error) {
				throw error
			}
			if (data && type === 'search') {
				const orders = [...new Map([...atom, ...data?.[outputFunction]]?.map((obj) => [JSON.stringify(obj?._id), obj])).values()]
				setAtom(orders)
			}
		},
	})

	return { queryFunction, loading }
}

export default useFetchLazyQuery
